import React from 'react';

interface BookingModalProps {
  open: boolean;
  onClose: () => void;
  vehicleName?: string;
}

const BookingModal: React.FC<BookingModalProps> = ({ open, onClose, vehicleName }) => {
  if (!open) return null;
  const subject = vehicleName
    ? `TiLimousine Booking Request for ${vehicleName}`
    : 'TiLimousine Booking Request';
  const body =
    (vehicleName ? `Vehicle: ${vehicleName}\n` : '') +
    'Name: \nPhone: \nPickup Location: \nDrop-off Location: \nDate & Time: \nAirport Name: \nFlight Number: \nSpecial Requests: ';
  const mailto = `mailto:contact@tilimousine.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

  return (
    <div className="booking-modal-overlay" onClick={onClose}>
      <div className="booking-modal" onClick={e => e.stopPropagation()}>
        <h3 className="modal-title">Book {vehicleName ? vehicleName : 'Your Ride'}</h3>
        <p className="modal-desc">How would you like to book?</p>
        <div className="modal-actions">
          <a href={mailto} className="gold-btn modal-btn">Book by Email</a>
          <a href="tel:+18573123332" className="gold-btn modal-btn">Book by Phone</a>
        </div>
        <button className="modal-close" onClick={onClose}>&times;</button>
      </div>
    </div>
  );
};

export default BookingModal; 